import styled from 'styled-components';

export const BannerImg = styled.img`
  flex-grow: 0 !important;
  flex-shrink: 0 !important;
  width: 100%;
  aspect-ratio: 1228/410;
  border-radius: 8px;
  object-fit: cover;
`;
